// extracted by mini-css-extract-plugin
export default {"finishModal":"FinishModal_finishModal__nCshP","modalHeader":"FinishModal_modalHeader__Fefvq"};